import { uniqBy } from 'lodash';
import { SALON_NAVIGAION, USER_NAVIGARION, VIEW_SERVICES } from '../constants';

export const setCookie = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};
export const getCookie = (name) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const eraseCookie = (name) => {
  document.cookie = name + '=; Max-Age=-99999999;';
};

export const setLoading = () => {
  document.querySelector('.loaderElement').style.display = 'block';
};

export const removeLoading = () => {
  document.querySelector('.loaderElement').style.display = 'none';
};

export const parseJwt = (token = getCookie('accessToken')) => {
  const tokenVar = token || localStorage.getItem('accessToken');
  if (!tokenVar) return {};
  var base64Url = tokenVar.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const returnNavigationObject = () => {
  const jwt = parseJwt();
  if (jwt) {
    if (jwt.salon_id) {
      SALON_NAVIGAION.salon = `${VIEW_SERVICES}/${jwt.salon_id}`;
      return SALON_NAVIGAION;
    }
    return USER_NAVIGARION;
  }
};

export const mergeSlotsForSelection = (slots) => {
  let slotsForKey = [];
  let mixSlots = [];

  for (let keys in slots) {
    slotsForKey = slots[keys].map((slot) => {
      slot.slot_id = keys;
      return slot;
    });
    mixSlots = mixSlots.concat(slotsForKey);
  }

  mixSlots.sort(function (a, b) {
    return (
      new Date('1970/01/01 ' + a.from.replace(/(am|pm)/, ' $1')) -
      new Date('1970/01/01 ' + b.from.replace(/(am|pm)/, ' $1'))
    );
  });
  const unique = uniqBy(mixSlots, 'from');
  return unique;
};

export const cloneWithParsing = (data) => {
  const clonedData = JSON.parse(JSON.stringify(data));
  return clonedData;
};

export const getItemFromLocalStorage = (item) =>
  JSON.parse(localStorage.getItem(item));

export const getItemFromSessionStorage = (item) =>
  JSON.parse(sessionStorage.getItem(item));

export const setItemInSessionStorage = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value));

export const getTotal = (selectedServices) => {
  const total = selectedServices.reduce((a, b) => a + b.discounted_price, 0);
  return total;
};

export const getExpensesTotal = (expenses, expense_type) => {
  const filteredExpenses = expenses.filter(
    (expense) => expense.expense_type === expense_type,
  );
  const total = filteredExpenses.reduce((a, b) => a + b.amount, 0);
  return total;
};

export const getDuration = (selectedServices) => {
  const duration = selectedServices.reduce(
    (a, b) => a + b.duration_in_minutes,
    0,
  );
  return duration;
};

export const invite = () => {
  var copyText = document.getElementById('myInput');
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand('copy');
};

const convertTime = (timeStr) => {
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':');
  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'pm') {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}`;
};

export const isPast = (date, time) => {
  const timeMod =
    time.indexOf('am') > -1 ? time.replace('am', '').trim() : convertTime(time);

  const myDate = new Date(`${date}T${timeMod}`).getTime();
  const myDate2 = new Date().getTime();
  if (myDate2 > myDate) {
    return true;
  }
  return false;
};


export const nFormatter = (num, digits)  =>{
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function(item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}